import Vue from 'vue'
import Vuex from 'vuex'
import {getCity, loginIndex, sendMsg, findBillSn, commit_code} from '../services/selectSide'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    tabType:'supplier',
    value: '', //要查询的内容
    information: [], //获取所有上传信息,
    check_code: '',
    message: '',
    userInfo: {},//用户信息
    flag: false, //弹框
    city: [],
    findBillList: [],
    btn: false,
    scan: {},//扫一扫参数
    isload: true,
    wx_code: '',//微信扫码登录的code
    register_param: '',
    // 当前文章id
    article: '',
    commonData: '',
    tipsFlag: {search_flag: false},
    redirectUrl: process.env.FASTGO_WEBSITE_URL,
    consoleUrl: process.env.CONSOLE_WEBSITE_URL,
    erpUrl: process.env.ERP_WEBSITE_URL,
    cookieBox: false,
    serviceAgreement: false,
    setTimeoutFn:''
  },
  mutations: {
    tabChange(state, payload){
      state.tabType = payload;
      console.log(state.tabType)
    },
    changeLoad(state, payload) {
      state.isload = payload;
    },
    changeUser(state, payload) {
      let user = {};
      state.userInfo = {};
      user.avatar = payload.data.avatar;
      user.nick_name = payload.data.user ? payload.data.user : '暂无' || payload.user.tel;
      user.uid = payload.data.uid;
      state.userInfo = user;
    },
    changeValue(state, payload) {
      state.value = payload;//保存用户要查询的内容
    },
    getAll(state, payload) {
      state.information = payload;
    },
    //短信页面随机码
    getIndex(state, payload) {
      console.log('随机码', payload)
      state.check_code = payload;
    },
    //国家
    getCity(state, payload) {
      state.city = payload;
    },
    changeMessage(state) {
      state.message = '';
    },
    changeBtn(state, payload) {
      state.btn = payload;
    },
    changeScan(state, payload) {
      state.scan = payload;
    },
    get_wx_code(state, payload) {
      state.wx_code = payload;
    },
    // 扫码登陆后获得的注册参数
    register_param(state, payload) {
      state.register_param = payload;
    },
    setArticle(state, payload) {
      state.article = payload;
    },
    setCommonData(state, payload) {
      state.commonData = payload;
    },
    setCookieBox(state, payload) {
      state.cookieBox = payload;
    },
    setServiceAgreement(state, payload) {
      state.serviceAgreement = payload;
    },
    setTipsFlag(state, payload) {
      clearTimeout(state.setTimeoutFn)
      if (payload.handle == undefined) {
        state.tipsFlag = payload;
        state.setTimeoutFn =  setTimeout(() => {
          state.tipsFlag.search_flag = false;
        }, 2000);
      } else {
        state.tipsFlag = payload;
      }

    }
  },
  actions: {
    //短信页面随机码
    async loginIndex(store) {
      let data = await loginIndex();
      store.commit('getIndex', data.data.check_code)
    },
    //短信
    async sendMsg(store, payload) {
      let datas = await sendMsg({
        payload,
        check_code: store.state.check_code
      });
      console.log('短信', datas)
    },
    //国家列表
    async getCities(store) {
      let data = await getCity();
      store.commit('getCity', data.data)
    },
    async findBillSn(store) {
      let data = await findBillSn()
      store.commit('changeScan', data.data)
    },
    // 微信扫码登录code与后台交换
    async commit_code(store, payload) {
      let data = await commit_code(payload);
      store.commit('register_param', data)

    },
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js